import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestDeleteDeliveryZone } from "./deleteDeliveryZone.request";

const useDeleteDeliveryZone = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestDeleteDeliveryZone,
    ...options
  });
};

export default useDeleteDeliveryZone;
